import styles from "./NotePopup.module.scss";
import React from "react";
import { Form } from "antd";
import { useTranslation } from "react-i18next";
import FormItemInput from "../../../../../components/ui/FormItemInput/FormItemInput";
import FormItemTextArea from "../../../../../components/ui/FormItemTextArea/FormItemTextArea";
import CustomButton from "../../../../../components/ui/CustomButton/CustomButton";
import { IUserNote, IUserNoteModel } from "../../../../../models/UserNote";

// Same limits as the server's USER_NOTE_LIMITS
const TITLE_MAX_LENGTH = 150;
const DESCRIPTION_MAX_LENGTH = 2000;

interface INotePopupProps {
  // null - adding a new note
  note: IUserNote | null;
  isSaving: boolean;
  onSave: (model: IUserNoteModel) => void;
  closePopup: () => void;
}

const NotePopup: React.FC<INotePopupProps> = ({ note, isSaving, onSave, closePopup }) => {
  const { t } = useTranslation();

  const onFinish = (values: IUserNoteModel) => {
    if (isSaving) return;
    onSave({ title: values.title.trim(), description: values.description.trim() });
  };

  return (
    <div className={styles.container} onClick={closePopup}>
      <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
        <h3 className={styles.title}>{note ? t("EditNote") : t("AddNote")}</h3>
        <Form
          className={styles.form}
          name="user-note"
          onFinish={onFinish}
          autoComplete="off"
          layout={"vertical"}
          initialValues={note ? { title: note.title, description: note.description } : undefined}
        >
          <FormItemInput
            name={"title"}
            label={t("Title")}
            placeholder={t("EnterATitle")}
            rules={{ required: true, whitespace: true }}
            maxLength={TITLE_MAX_LENGTH}
          />
          <FormItemTextArea
            name={"description"}
            label={t("Description")}
            placeholder={t("EnterADescription")}
            rules={{ required: true, whitespace: true }}
            maxLength={DESCRIPTION_MAX_LENGTH}
          />

          <div className={styles.btnsWrapper}>
            <CustomButton
              text={t("Cancel")}
              type={"button"}
              typeStyle={"outline"}
              functionOnClick={closePopup}
            />
            <CustomButton text={t("Save")} type={"submit"} typeStyle={"fill"} />
          </div>
        </Form>
      </div>
    </div>
  );
};

export default NotePopup;
